import * as React from "react";
import { FormikProps } from "formik";
import numeral from "numeral";
import { FormValues } from "../../support/FormValues";
import { AccountTypeEnum } from "../../support/AccountTypeEnum";
import { TransferInstructionsEnum } from "../../support/TransferInstructionsEnum";

import bootstrapStyles from "../../css/bootstrap.module.css";
import ReviewData from "../../components/Review/ReviewData";
import ReviewHeader from "../../components/Review/ReviewHeader";

interface ReviewProps {
  formikBag: FormikProps<FormValues>;
}

const ReviewTransferInformation = ({ formikBag: { values } }: ReviewProps) => {
  return (
    <div className="reviewTransferInformation-wrapper">
      <ReviewHeader
        label="Transfer Instructions"
        navigation="/transferDetails"
      />

      <div className={bootstrapStyles.row}>
        <ReviewData
          id="currentFirm"
          reviewLabel="Firm Name"
          reviewData={values.currentFirm}
        />
        {/* If your currentAccountType has a portion of Roth then you have 2 different toAccountType */}
        {values.rothPortion === "Some" ? (
          <ReviewData
            id="toAccountType"
            reviewLabel="Transfer Account To"
            reviewData={`${values.toAccountType} & Roth IRA`}
          />
        ) : (
          <ReviewData
            id="toAccountType"
            reviewLabel="Transfer Account To"
            reviewData={values.toAccountType}
          />
        )}
      </div>

      <div className={bootstrapStyles.row}>
        <ReviewData
          id="currentAccount"
          reviewLabel="Account Number"
          reviewData={values.currentAccount}
        />
        {values.transferInstructions === TransferInstructionsEnum.All && (
          <ReviewData
            id="transferInstructions"
            reviewLabel="Transfer Instruction"
            reviewData={`${values.transferInstructions}`}
          />
        )}
        {values.transferInstructions === TransferInstructionsEnum.Dollar && (
          <ReviewData
            id="transferInstructions"
            reviewLabel="Transfer Instruction"
            reviewData={`$${numeral(values.transferDollarAmount).format(
              "0,0.00"
            )}`}
          />
        )}
        {values.transferInstructions === TransferInstructionsEnum.Percent && (
          <ReviewData
            id="transferInstructions"
            reviewLabel="Transfer Instruction"
            reviewData={`${values.transferPercent}%`}
          />
        )}
      </div>

      <div className={bootstrapStyles.row}>
        <ReviewData
          id="currentAccountType"
          reviewLabel="Account Type"
          reviewData={values.currentAccountType}
        />
        {values.transferInstructions === TransferInstructionsEnum.All && (
          <ReviewData
            id="approximateValue"
            reviewLabel="Approximate Value"
            reviewData={`$${numeral(values.transferDollarEstimate).format(
              "0,0.00"
            )}`}
          />
        )}
      </div>

      <div className={bootstrapStyles.row}>
        {values.currentAccountType === AccountTypeEnum.SimpleIRA && (
          <ReviewData
            id="initialFundingDate"
            reviewLabel="Initial Contribution Date"
            reviewData={values.initialFundingDate}
          />
        )}
        {values.currentAccountType === AccountTypeEnum.RothIRA && (
          <ReviewData
            id="rothYear"
            reviewLabel="Roth Initial Contribution Year"
            reviewData={values.rothYear}
          />
        )}
      </div>
    </div>
  );
};

export default ReviewTransferInformation;
